export default __webpack_public_path__ + "static/media/icons8-open-end-wrench.84821d57.svg";